import React, { ReactNode } from 'react';
import { Modal, Flex, Box, Typography } from '@fullstory/components';
import { FGACButton } from '../FGACButton';
import { FormattedMessage } from 'react-intl';

interface ArchiveSegmentModalProps extends React.ComponentProps<typeof Modal> {
  segmentName: string;
  onSubmit: () => void;
  disabled: boolean;
  tooltip?: ReactNode;
}

export const ArchiveSegmentModal: React.FC<ArchiveSegmentModalProps> = ({
  segmentName,
  disabled,
  tooltip,
  onSubmit,
  ...rest
}) => (
  <Modal data-component="ArchiveSegmentModal" {...rest} size="small">
    <Modal.Header onCloseSignal={rest.onCloseSignal}>
      <FormattedMessage defaultMessage="Archive segment" id="btLzp+" />
    </Modal.Header>
    <Modal.Body>
      <Flex
        column
        style={{ width: '100%' }}
        alignItems="stretch"
        className="fs_delete_segment_modal"
      >
        <Box marginBottom={20}>
          <Typography variant="body4" color="neutrals-n7">
            <FormattedMessage
              defaultMessage="The Segment you’re trying to archive may be used by other Fullstory features.
                              Archiving this Segment might impact other workflows, such as Conversions Analysis, Data
                              Exports, Dashboards, Metrics, Funnels, or Alerts. Are you sure you want to archive this Segment?"
              id="P1/wmt"
            />
          </Typography>
        </Box>
        <FGACButton
          iconOnly={false}
          onClick={onSubmit}
          disabled={disabled}
          tooltip={tooltip}
          fullWidth
          justifyContent="center"
          variant="fill-destructive"
        >
          <FormattedMessage
            defaultMessage='Archive "{segmentName}"'
            id="b0IwwF"
            values={{ segmentName }}
          />
        </FGACButton>
      </Flex>
    </Modal.Body>
  </Modal>
);
